import $ from 'jquery';

export default function formh() {
  
  
  function init() {
	var today = new Date();
	var tomorrow = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
	var dd = today.getDate();
	var mm = today.getMonth()+1; //January is 0!
	var yyyy = today.getFullYear();
	var tomday = tomorrow.getDate();
	var tommonth = tomorrow.getMonth() + 1;
	var tomyear = tomorrow.getFullYear();
	if(dd<10){dd='0'+dd} if(mm<10){mm='0'+mm} today = yyyy+'-'+mm+'-'+dd;
	if(tomday<10){tomday='0'+tomday} if(tommonth<10){tommonth='0'+tommonth} tomorrow = tomyear+'-'+tommonth+'-'+tomday;
	$('#checkin').attr({value: today});
	$('#checkout').attr({value: tomorrow});
	
    $('#checkin').change(function(){
		if($('#checkin').val() != ''){
			var split = $('#checkin').val().split('-');
			$('#giorno_inizio').attr({value: split[2]});
			$('#mese_inizio').attr({value: split[1]});
			$('#anno_inizio').attr({value: split[0]});
		}else{
			$('#giorno_inizio').attr({value: ''});
			$('#mese_inizio').attr({value: ''});
			$('#anno_inizio').attr({value: ''});
		}
	});
	$('#checkout').change(function(){		
		if($('#checkout').val() != ''){		
			var split = $('#checkout').val().split('-');
			$('#giorno_fine').attr({value: split[2]});
			$('#mese_fine').attr({value: split[1]});
			$('#anno_fine').attr({value: split[0]});
		}else{
			$('#giorno_fine').attr({value: ''});
			$('#mese_fine').attr({value: ''});
			$('#anno_fine').attr({value: ''});
		}
	});
  }
  
  if($('#checkin').length > 0) {
    $( document ).ready(function() {
      init()
    });
  }
}


// WEBPACK FOOTER //
// ./src/assets/js/formh.js